import { makeStyles, tokens } from "@fluentui/react-components";
import { AppBarBottomMargin } from "./Constants";
/**
 * Styles for the FlexPanel control
 */
export const useFlexPanelStyles = makeStyles({
  root: {
    display: "flex",
    alignItems: "center",
  },
  wrap: {
    flexWrap: "wrap",
  },
  resizable: {
    overflowY: "clip",
  },
  column: {
    flexDirection: "column",
  },
  transparent: {
    backgroundColor: tokens.colorTransparentBackground,
  },
  fill: {
    flexGrow: 1,
    paddingBottom: `${AppBarBottomMargin}px`,
  },
  mercuryFlex: {
    overflowY: "visible",
  },
});
